var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dropdown-field",
      on: {
        click: function($event) {
          _vm.openData = !_vm.openData
        }
      }
    },
    [
      _c("div", { staticClass: "section" }, [
        this.siteCode === this.$config.SITECODE_OGHCM
          ? _c("span", [
              _vm._v(
                _vm._s(/*보통예금(개인용) - 비대면 가입*/ _vm.$t("EKYC-06-01"))
              )
            ])
          : _c("span", { domProps: { innerHTML: _vm._s(_vm.prdctName) } }),
        !_vm.openData ? _c("i", { staticClass: "icon icon-list" }) : _vm._e(),
        _vm.openData
          ? _c("i", {
              staticClass: "icon icon-dropdown-arrow",
              class: { rotate180: _vm.openData }
            })
          : _vm._e()
      ]),
      _vm.openData
        ? _c("div", { staticClass: "dropdown-field--list" }, [
            this.siteCode === this.$config.SITECODE_OGHCM
              ? _c("div", [
                  _c("div", { staticClass: "list-item" }, [
                    _c("div", { staticClass: "tit" }, [
                      _vm._v(_vm._s(/*상품정보*/ _vm.$t("EKYC-06-02")))
                    ]),
                    _c("div", { staticClass: "dec" }, [
                      _vm._v(
                        _vm._s(
                          /* 일시적 여유자금 보관목적으로 수시로 입금 및 출금을 할 수 있고 예치기간을 정하지 않은 예금 */ _vm.$t(
                            "EKYC-06-03"
                          )
                        )
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "list-item" }, [
                    _c("div", { staticClass: "tit" }, [
                      _vm._v(_vm._s(/*가입대상*/ _vm.$t("EKYC-06-04")))
                    ]),
                    _c("div", { staticClass: "dec" }, [
                      _vm._v(
                        _vm._s(
                          /* 개인 (IC칩 신분증을 소지한 18세 이상 베트남 거주자) */ _vm.$t(
                            "EKYC-06-05"
                          )
                        )
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "list-item" }, [
                    _c("div", { staticClass: "tit" }, [
                      _vm._v(_vm._s(/*가입통화 및 이율*/ _vm.$t("EKYC-06-06")))
                    ]),
                    _c("div", { staticClass: "dec" }, [
                      _vm._v(
                        _vm._s(
                          /* VND 연 0.10% (고객별 1좌 개설가능) */ _vm.$t(
                            "EKYC-06-07"
                          )
                        )
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "list-item" }, [
                    _c("div", { staticClass: "tit" }, [
                      _vm._v(_vm._s(/*이체한도*/ _vm.$t("EKYC-06-08")))
                    ]),
                    _c("div", { staticClass: "dec" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            /* 1일 5억 VND 비대면 이체한도 제한*/ _vm.$t(
                              "EKYC-06-09"
                            )
                          )
                      ),
                      _c("br"),
                      _vm._v(
                        _vm._s(
                          /* (신분증을 지참하여 영업점 방문 시 한도제한 해제 가능) */ _vm.$t(
                            "EKYC-06-10"
                          )
                        ) + " "
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "list-item" }, [
                    _c("div", { staticClass: "tit" }, [
                      _vm._v(_vm._s(/*수수료*/ _vm.$t("EKYC-06-11")))
                    ]),
                    _c("div", { staticClass: "dec" }, [
                      _vm._v(_vm._s(/*해당무*/ _vm.$t("EKYC-06-12")))
                    ])
                  ])
                ])
              : _c("div", [
                  _c("div", { staticClass: "list-item" }, [
                    _c("div", { staticClass: "tit" }, [
                      _vm._v(_vm._s(/*상품 정보*/ _vm.$t("MDEP-01-01-14-02")))
                    ]),
                    _c("div", {
                      staticClass: "dec",
                      domProps: { innerHTML: _vm._s(_vm.prdctBrifCtnt) }
                    })
                  ]),
                  _c("div", { staticClass: "list-item" }, [
                    _c("div", { staticClass: "tit" }, [
                      _vm._v(
                        _vm._s(/*금리 및 이율*/ _vm.$t("MDEP-01-01-14-04"))
                      )
                    ]),
                    _c("div", { staticClass: "dec" }, [
                      _c("p", {
                        domProps: { innerHTML: _vm._s(_vm.prdctIrtBrifCtnt) }
                      })
                    ])
                  ]),
                  _vm.step >= 1 || _vm.step == 0
                    ? _c("div", { staticClass: "list-item" }, [
                        _c("div", { staticClass: "tit" }, [
                          _vm._v(
                            _vm._s(/*통화 종류*/ _vm.$t("MDEP-01-01-14-05"))
                          )
                        ]),
                        _c("div", { staticClass: "dec" }, [
                          _c("p", [
                            _vm._v(_vm._s(_vm.depositNewReqInfo.cncycd))
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.step >= 1 || _vm.step == 0
                    ? _c("div", { staticClass: "list-item" }, [
                        _c("div", { staticClass: "tit" }, [
                          _vm._v(
                            _vm._s(/*가입 금액*/ _vm.$t("MDEP-01-01-14-06"))
                          )
                        ]),
                        _c("div", { staticClass: "dec" }, [
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$num(
                                  _vm.depositNewReqInfo.dpostBal,
                                  null,
                                  true
                                )
                              )
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm.step >= 1 || _vm.step == 0
                    ? _c("div", { staticClass: "list-item" }, [
                        _c("div", { staticClass: "tit" }, [
                          _vm._v(
                            _vm._s(/*가입 기간*/ _vm.$t("MDEP-01-01-14-07"))
                          )
                        ]),
                        _c("div", { staticClass: "dec" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.depositNewReqInfo.indpCnpr.ctrcTrmCnt
                              ) +
                                " " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.$ctrcUnitDstcdType(
                                      _vm.depositNewReqInfo.indpCnpr
                                        .ctrcTrmUnitDstic
                                    )
                                  )
                                )
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  (_vm.step >= 2 || _vm.step == 0) &&
                  _vm.depositNewReqInfo.isStpulCfm
                    ? _c("div", { staticClass: "list-item" }, [
                        _c("div", { staticClass: "tit" }, [
                          _vm._v(
                            _vm._s(/*약관 동의*/ _vm.$t("MDEP-01-01-14-09"))
                          )
                        ]),
                        _c("div", { staticClass: "dec" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(/*동의함*/ _vm.$t("MDEP-01-01-14-10"))
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.step >= 3
                    ? _c("div", { staticClass: "list-item" }, [
                        _c("div", { staticClass: "tit" }, [
                          _vm._v(
                            _vm._s(/*출금계좌*/ _vm.$t("MDEP-01-01-14-11"))
                          )
                        ]),
                        _c("div", { staticClass: "dec" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.depositNewReqInfo.accountingCommon.cupldAcno
                              )
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.step >= 3 && _vm.getGL0000205.strBrncoPrdctCd != "1102"
                    ? _c("div", { staticClass: "list-item" }, [
                        _c("div", { staticClass: "tit" }, [
                          _vm._v(
                            _vm._s(/*자동이체 계좌*/ _vm.$t("MDEP-01-01-14-12"))
                          )
                        ]),
                        _c("div", { staticClass: "dec" }, [
                          _c("p", [
                            _vm._v(_vm._s(_vm.depositNewReqInfo.lnkgAcno))
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.step >= 4
                    ? _c("div", { staticClass: "list-item" }, [
                        _c("div", { staticClass: "tit" }, [
                          _vm._v(
                            _vm._s(/*만기후 처리*/ _vm.$t("MDEP-01-01-16-12"))
                          )
                        ]),
                        _c("div", { staticClass: "dec" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  _vm.depositNewReqInfo.autoExpirExtenYn +
                                    "_예금만기후처리"
                                )
                              )
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.step >= 4 && _vm.depositNewReqInfo.expirExtenFormDstcd
                    ? _c("div", { staticClass: "list-item" }, [
                        _c("div", { staticClass: "tit" }, [
                          _vm._v(
                            _vm._s(/*자동연장 금액*/ _vm.$t("MDEP-01-01-16-13"))
                          )
                        ]),
                        _c("div", { staticClass: "dec" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.depositNewReqInfo.expirExtenFormDstcd == "1"
                                  ? /*원금*/ _vm.$t("MDEP-01-01-13-09")
                                  : /*원금+이자*/ _vm.$t("MDEP-01-01-13-10")
                              )
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.step >= 4 && _vm.depositNewReqInfo.brncoIntPaymtCyclDstcd
                    ? _c("div", { staticClass: "list-item" }, [
                        _c("div", { staticClass: "tit" }, [
                          _vm._v(
                            _vm._s(
                              /*이자 지급 방식*/ _vm.$t("MDEP-01-01-13-13")
                            )
                          )
                        ]),
                        _c("div", { staticClass: "dec" }, [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.depositNewReqInfo.brncoIntPaymtCyclDstcd ==
                                  "0"
                                  ? /*만기지급식*/ _vm.$t("MDEP-01-01-13-14")
                                  : /*월이자지급식*/ _vm.$t("MDEP-01-01-13-15")
                              )
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.step >= 4 &&
                  _vm.getGL0000205.strBrncoPrdctCd == "1102" &&
                  _vm.depositNewReqInfo.lnkgAcno
                    ? _c("div", { staticClass: "list-item" }, [
                        _c("div", { staticClass: "tit" }, [
                          _vm._v(
                            _vm._s(/*연결계좌번호*/ _vm.$t("MDEP-01-01-13-16"))
                          )
                        ]),
                        _c("div", { staticClass: "dec" }, [
                          _c("p", [
                            _vm._v(_vm._s(_vm.depositNewReqInfo.lnkgAcno))
                          ])
                        ])
                      ])
                    : _vm._e()
                ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }